import DefaultFormFilter from './defaultFormFilter'
import { Button, Row } from 'antd'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

interface IProps {
  onClickBtnAdd?: () => void
  onSearch?: (value: string) => void
  children?: React.ReactNode
  renderRight?: React.ReactNode
  className?: string
  buttonLabel?: string
}

const StyledRowContainer = styled(Row)`
  justify-content: space-between;
  background: white;
  box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);
  margin-bottom: 8px;
  border-radius: 8px;
  padding: 16px;
  align-items: center;
`
const StyledContent = styled(Row)`
  flex: 1;
`

const FilterLayout = (props: IProps) => {
  const {
    onClickBtnAdd,
    children,
    onSearch,
    renderRight,
    buttonLabel = ''
  } = props
  const [labelStyle, setLabelStyle] = useState<{
    width?: number
    height?: number
  } | null>(null)
  const [labelIcon, setLabelIcon] = useState<any>()
  useEffect(() => {
    if (buttonLabel != '') setLabelStyle(null)
    setLabelStyle(buttonLabel ? null : { width: 34, height: 34 })
    setLabelIcon(
      buttonLabel ? (
        <img src="/images/ic-add.svg" alt="" style={{ marginRight: 4 }} />
      ) : (
        <img src="/images/ic-add-simple.svg" alt="" />
      )
    )
  }, [buttonLabel])
  return (
    <StyledRowContainer className={props?.className}>
      <StyledContent>
        {children ? children : <DefaultFormFilter onSearch={onSearch} />}
      </StyledContent>
      {renderRight ? (
        renderRight
      ) : (
        <Button
          type="primary"
          loading={false}
          onClick={onClickBtnAdd}
          style={{
            ...labelStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          icon={labelIcon}>
          {t(`${buttonLabel}`)}
        </Button>
      )}
    </StyledRowContainer>
  )
}

export default FilterLayout
